<template>
  <div id="story">
    <div v-if="elements.length == 0" class="underline">{{$translate('NO_INCIDENT_DATA')}}</div>
    <div v-else class="container">
      <div v-for="(i, index) in elements" :key="index" class="story-container">
        <div :span="15">
          <p class="story-title">{{i.userName}}</p>
        </div>
        <div :span="9">
          <p class="story-title">{{getDate(i.dateTime)}}</p>
        </div>
        <p class="story-text">{{i.text}}</p>
        <img :src="i.photo" class="image_presentation">
      </div>
    </div>
  </div>
</template>
<script>
import IncidentAspect from "../aspects/IncidentAspect.js";
import BasePointAspect from "../aspects/BasePointAspect.js";
import BaseComponent from "./base/BaseComponent.vue";
export default {
  extends: BaseComponent,
  name: "IncidentStoryBoard",
  props: {
    elements: Array,
    loading: Boolean()
  },
  data() {
    return {
      story: "",
      options: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      }
    };
  },
  mounted() {
    this.story = document.getElementById("story");
  },
  methods: {
    getDate(date) {
      let d = new Date(date);
      return d.toLocaleDateString("nl-NL", this.options);
    },
    save() {
      let requestObject = IncidentAspect._createRequestObject(this.form);

      const request = window.dssUtility.createDSSRequest(
        this.userGroup.id,
        "addIncidentAct",
        requestObject
      );
      this.loading = true;
      window.socket.sendMessage(
        request,
        data => {
          this.loading = false;

          this.$notify.success({
            title: this.$translate("OBJECT_ADDED"),
            message: "Success"
          });

          this.saveLock = true;
          this.settingLock = false;
        },
        () => {
          this.loading = false;
          this.$notify.error({
            title: this.$translate("OBJECT_FAILS_TO_REMOVE"),
            message: "ERROR",
            duration: 0
          });
        }
      );
    },
    savePhoto() {
      const requestObject = IncidentAspect._createAttachmentRequestObject(
        this.form
      );
      const request = window.dssUtility.createDSSRequest(
        this.userGroup.id,
        "insertAttachmentAct",
        requestObject
      );


      this.loading = true;
      window.socket.sendMessage(
        request,
        data => {
          this.loading = false;
          this.$notify.success({
            title: this.$translate("OBJECT_ADDED"),
            message: "Success"
          });
        },
        () => {
          this.loading = false;
          this.$notify.error({
            title: this.$translate("OBJECT_FAILS_TO_REMOVE"),
            message: "ERROR",
            duration: 0
          });
        }
      );
    }
  }
};
</script>
<style lang='scss' scoped>
.story-board {
  margin: 5px 5px 5px 0px;
  width: 100%;
}
.story-container {
  width: 100%;
  height: auto;
  max-height: 200px;
  background-color: #cde2e9;
  border-radius: 10px;
  min-height: 150px;
  overflow: hidden;
  margin-bottom: 5px;
}
.story-title {
  font-size: 12px;
  padding: 3px 0px 4px 6px;
  margin: 0px !important;
}

.story-text {
  font-size: 12px;
  margin: 0px !important;
}

.image_presentation {
  max-height: 200px;
  width: auto;
  height: auto;
}

#location {
  display: none;
}

.information-text {
  font-size: 0.9em;
  margin: 15px 0px 7.5px 0px;
}

#small-button_light {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0px 0px !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: rgba(0, 0, 0, 0);
  color: #000;
}

#small-button_dark {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0px 0px !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: #196f93;
  color: #fff;
}

.small-button_light {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0px 0px !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: rgba(0, 0, 0, 0);
  color: #000;
}

.small-button_dark {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0px 0px !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: #196f93;
  color: #fff;
}

.button {
  width: 100% !important;
  text-align: center !important;
  height: 30px;
  padding: 0px 0px !important;
  border-radius: 2px !important;
  border: none;
  background-color: #84b7c9;
  color: white;
}

.select {
  width: 97%;
  font-size: 12px !important;
}

.m-top {
  margin-top: 15px;
}

.container {
  max-height: 200px;
}

.small-margin {
  margin-top: 2.5px;
}
</style>
